export class GetFarmIdByNameUseCase {
  constructor(repository) {
    this.repository = repository
  }
  async execute(name) {
    const resp= await this.repository.getFarmIdByName(name)

    return resp
  }
}
